import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CmpsChartModule } from '../../../coaching-commitment/chart.module';
import { CmpsLazyI18nModule } from '../../../i18n/i18n.module';
import { TranslationIdMap } from '../focus-selector.i18n';

import { GoalChartCommitmentComponent } from './goal-chart-commitment.component';

@NgModule({
    imports: [
        CmpsChartModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CommonModule,
    ],
    declarations: [GoalChartCommitmentComponent],
    exports: [GoalChartCommitmentComponent],
})
export class GoalChartCommitmentModule {}
